import { render, staticRenderFns } from "./NewRealEstateActModal.vue?vue&type=template&id=450ffc2d&scoped=true&"
import script from "./NewRealEstateActModal.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateActModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ffc2d",
  null
  
)

export default component.exports